import {
  Card,
  CardContent,
  CardHeading,
  FigureLabel,
  Skeleton,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui'

const STAT_TITLES = ['Total inflows', 'Total outflows', 'Total transactions']
const ACCOUNT_COLUMNS = [
  'number',
  'owner',
  'institution',
  'type',
  'inflows',
  'outflows',
  'count',
]

interface TransactionsSummarySkeletonProps {
  accountCount: number
}

// Holds the accounts, stats and timeline in place, built from the same primitives at the same sizes,
// so the ledger below doesn't jump when the full list lands and the real sections replace this.
export const TransactionsSummarySkeleton = ({
  accountCount,
}: TransactionsSummarySkeletonProps) => {
  const accountRows = Array.from(
    { length: Math.max(accountCount, 1) },
    (_, index) => index,
  )

  return (
    <>
      <section className="overflow-hidden rounded-lg border bg-white">
        <h3 className="px-6 py-4 font-semibold leading-none tracking-tight">
          Accounts
        </h3>
        <div className="max-h-[400px] w-full overflow-hidden border-t">
          <table className="w-full text-sm">
            <TableHeader className="bg-blue-1">
              <TableRow className="bg-blue-1">
                {ACCOUNT_COLUMNS.map((column) => (
                  <TableHead key={column}>
                    <Skeleton className="h-3 w-16" />
                  </TableHead>
                ))}
              </TableRow>
            </TableHeader>
            <TableBody>
              {accountRows.map((row) => (
                <TableRow key={row}>
                  {ACCOUNT_COLUMNS.map((column) => (
                    <TableCell key={column}>
                      <Skeleton className="h-5 w-20" />
                    </TableCell>
                  ))}
                </TableRow>
              ))}
            </TableBody>
          </table>
        </div>
      </section>

      <div className="@container">
        <div className="grid grid-cols-1 gap-4 @3xl:grid-cols-3">
          {STAT_TITLES.map((title) => (
            <Card key={title} className="p-6">
              <FigureLabel>{title}</FigureLabel>
              <Skeleton className="mt-1 h-8 w-36" />
            </Card>
          ))}
        </div>
      </div>

      <div className="space-y-3">
        <div className="flex items-center justify-end gap-4">
          <Skeleton className="h-8 w-28 rounded-md" />
        </div>
        <Card className="w-full">
          <CardHeading title="Transaction timeline" />
          <CardContent>
            <Skeleton className="h-80 w-full" />
          </CardContent>
        </Card>
      </div>
    </>
  )
}
